import {useCallback} from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheRemove from "../../core/services/query/hooks/useCacheRemove";
import {PAYMENT_CARDS_CACHE_KEY} from "./usePaymentCardsGet";
import {ME_BASE_URL} from "../../../config/config";

export default function usePaymentCardSetPrimary(): (id: string) => Promise<void> {
    const client = useAPIClient(ME_BASE_URL, false);
    const removeCache = useCacheRemove();

    return useCallback(async (id: string) => {
        await client.patch(`payment_cards/${id}`, {principal: true});
        removeCache([PAYMENT_CARDS_CACHE_KEY]);
    }, [client, removeCache]);
}
